import "../ChannelContent/style.scss";

import DateFormComponent from "components/shared/FormComponent/DateFormComponent";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import type { TControlNameSpecificChannels } from "components/TitleFormContainer/types";
import { useTranslation } from "react-i18next";

interface ISubscriptionChannelContent {
    /**
     * Index of the channel
     */
    index: number;
    /**
     * React useFormContext() hooks
     */
    useFormContextData: any;
    /**
     * Name of the specific channel to control with useForm()
     */
    controlName: TControlNameSpecificChannels;
    showName?: boolean;
    showEan13?: boolean;
    showReleaseDate?: boolean;
}

const SubscriptionChannelContent = ({
    index,
    useFormContextData,
    controlName,
    showName = false,
    showEan13 = false,
    showReleaseDate = false,
}: ISubscriptionChannelContent) => {
    const [t] = useTranslation();
    const { control, errors } = useFormContextData;

    return (
        <div className="specific-channel-content flex flex-col gap-1.5">
            {(showName || showReleaseDate) && (
                <div className="top-content flex justify-between gap-10">
                    {showName && (
                        <TextFormComponent
                            className={showReleaseDate ? "w-1/2" : "w-full"}
                            control={control}
                            label={t("NewTitle.Title")}
                            controlName={controlName.name}
                            size="small"
                        />
                    )}
                    {showReleaseDate && (
                        <div className="w-1/2">
                            <DateFormComponent
                                control={control}
                                label={t("NewTitle.ReleaseDate")}
                                controlName={controlName.releaseDate}
                                size="small"
                                maxYearDistance={10}
                            />
                        </div>
                    )}
                </div>
            )}

            <div className="bottom-content flex justify-between gap-10">
                {showEan13 && (
                    <TextFormComponent
                        className="w-1/2"
                        control={control}
                        label={t("NewTitle.ISBN")}
                        controlName={controlName.ean13}
                        size="small"
                        error={errors.overriddenChannelsData && errors.overriddenChannelsData[index]?.ean13}
                        required
                    />
                )}
                <div className={`form-price-data-wrapper ${showEan13 ? "w-1/2" : "w-full"}`}>
                    <TextFormComponent
                        label={t("Subscription.Coefficient")}
                        control={control}
                        controlName={controlName.subscriptionCoefficient}
                        placeholder="1.0"
                        customValidate={(value) => !isNaN(+String(value).replace(",", "."))}
                        size="small"
                        error={
                            errors.overriddenChannelsData &&
                            errors.overriddenChannelsData[index]?.subscriptionCoefficient
                        }
                        required
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionChannelContent;
